<template>
  <!-- 接口 -->
  <div class="ff_interface">
    <div class="td-header">
      <div class="tdh-left">
        <span class="tdhl-rect-icon" />
        <router-link
          tag="span"
          to="/workbench"
          class="tdhl-title"
        >应用中心</router-link>
        <span class="su-icon-arrow tdhl-arrow-icon" />
        <span class="tdhl-subtitle">接口管理</span>
      </div>
      <router-link
        tag="span"
        to="/workbench"
        class="tdh-right"
      >返回到工作台</router-link>
    </div>
    <div
      class="dict-managed"
      style="margin: 20px; box-shadow: 0px 2px 10px 0px rgba(39, 56, 70, 0.1);background:#fff"
    >
      <div class="im-header">
        <div class="imh-left">
          <sw-button
            icon="su-icon-plus"
            type="primary"
            @click="addInterface"
          >新增接口</sw-button>
        </div>
        <div class="imh-right">
          <el-select
            v-model="searchType"
            placeholder="请选择"
            style="width: 105px"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <sw-search
            :placeholder="'请输入相关字段'"
            style="height: 32px; width: 260px"
            @search="searchHandle"
          />
          <div
            class="imhr-renew"
            @click="getData('', 'renew')"
          >
            <i class="su-icon-renew" />
          </div>
        </div>
      </div>
      <div
        v-loading="tableLoading"
        class="im-main"
      >
        <sw-table
          :show-selection="false"
          :table-name="'ff-interface'"
          :table-data="tableData"
          :table-title="tableTitle"
          :table-operation="tableOperation1"
          :page-sizes="[5, 10, 15, 20]"
          :total-count="tableCount"
          :page-size="pageSize"
          :has-add-button="false"
          @operation-handle="operationHandle"
          @selection-change="selectionChange"
          @size-change="changeSize"
          @change-page="changePage"
          @next-page="changePage"
          @prev-page="changePage"
        />
      </div>
      <sw-slide-dialog
        :visible.sync="dialogFlag"
        :title="currentDialogTitle"
        width="40%"
      >
        <span slot="footer">
          <sw-button
            size="small"
            @click="dialogFlag=!dialogFlag"
          >取 消</sw-button>
          <sw-button
            size="small"
            type="primary"
            @click="submitDialogForm('imDiaLogForm')"
          >确 定</sw-button>
        </span>
        <el-form
          ref="imDiaLogForm"
          :model="imDiaLogForm"
          :rules="imdfRules"
          :sw-validator="true"
          class="im-dialog-form"
          label-width="100px"
        >
          <Divider style="margin-left: 10px">基础信息</Divider>
          <el-form-item
            label="接口名称"
            prop="name"
          >
            <el-input
              v-model="imDiaLogForm.name"
              autocomplete="off"
              placeholder="请填写接口名称"
            />
          </el-form-item>
          <el-form-item
            label="地址URL"
            prop="url"
          >
            <el-input
              v-model="imDiaLogForm.url"
              autocomplete="off"
              placeholder="例：https://xxx.xxx.com"
            />
          </el-form-item>
          <el-form-item
            label="提交方式"
            prop="method"
          >
            <el-select
              v-model="imDiaLogForm.method"
              placeholder="请选择"
              style="width: 105px"
            >
              <el-option
                label="POST"
                value="POST"
              />
              <el-option
                label="GET"
                value="GET"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="定值参数">
            <sw-button
              type="primary"
              @click="addParams"
            >添加参数</sw-button>
          </el-form-item>
          <el-form-item
            v-for="(item,index) in imDiaLogForm.params"
            :key="index"
            :label="'参数' + (index + 1)"
          >
            <el-input
              v-model="item.name"
              style="width: 100px"
              placeholder="参数名"
            />
            =
            <el-input
              v-model="item.value"
              style="width: 100px"
              placeholder="参数值"
            />
            <sw-button
              style="margin-left: 20px"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="deleteRowParam(index)"
            />
          </el-form-item>
          <el-form-item label="动态参数">
            <sw-button
              type="primary"
              @click="addVariables"
            >添加参数</sw-button>
          </el-form-item>
          <el-form-item
            v-for="(item,index) in imDiaLogForm.variables"
            :key="'v'+index"
            :label="'参数' + (index + 1)"
          >
            <el-input
              v-model="item.name"
              style="width: 100px"
              placeholder="参数名"
            />
            <sw-button
              style="margin-left: 20px"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="deleteRowVariable(index)"
            />
          </el-form-item>
          <el-form-item
            label="权限范围"
            prop="scope"
          >
            <el-radio
              v-model="imDiaLogForm.scope"
              label="public"
            >公有</el-radio>
            <el-radio
              v-model="imDiaLogForm.scope"
              label="group"
            >此应用组</el-radio>
          </el-form-item>
          <sw-button
            style="margin: 0 0 20px 20px"
            type="primary"
            @click="testUrl('imDiaLogForm')"
          >测试一下</sw-button>
          <br>
          <textarea
            v-if="urlReturn"
            v-model="urlReturn"
            style="width: calc(100% - 20px); min-height: 400px; margin-left: 20px"
            disabled
          />
          <div
            v-if="urlReturnKey.length"
            style="margin: 20px 0 50px 20px;"
          >
            需要字段
            <el-checkbox-group v-model="checkList">
              <el-checkbox
                v-for="(item, index) in urlReturnKey"
                :key="index"
                :label="item"
                style="margin-top: 10px;"
              />
            </el-checkbox-group>
          </div>
          <!-- 新增模板格式 -->
          <el-form-item label="编辑需要字段" class="templateFormate">
            <el-input style="width: 100%" placeholder="参考格式：" disabled></el-input>
            <textarea v-model="jsonTemplate" style="width: calc(100%); min-height: 120px;" :placeholder="jsonTemplate"/>
            <textarea v-model="template" style="width: calc(100%); min-height: 150px;" placeholder="参照上面的格式，只需要改变label和value的值（值就是需要的字段名）"/>
          </el-form-item>
        </el-form>
      </sw-slide-dialog>
    </div>
  </div>
</template>
<script>
import Divider from '@/views/formflow/components/divider'
import '@/views/formflow/css/interface.scss'
import service from '@/utils/service.js'
import { resolveJson } from '@/utils/index.js'
export default {
  components: {
    Divider
  },
  data () {
    return {
      tableLoading: false,
      currentPage: 1,
      pageSize: 10,
      searchValue: '',
      options: [{
        value: 'interfaceName',
        label: '接口名称'
      }, {
        value: 'interfaceURL',
        label: 'URL'
      }],
      searchType: 'interfaceName',
      tableCount: 0,
      tableData: [
      ],
      tableTitle: [
        { prop: 'name', label: '接口名称', width: '120', sortable: true },
        { prop: 'url', label: 'URL', width: '120', sortable: true },
        { prop: 'method', label: '提交方式', width: '120', sortable: false },
        { prop: 'scope', label: '接口权限', width: '120', sortable: true }
      ],
      tableOperation1: [
        { name: '编辑', icon: 'su-icon-edit', operation: 'edit' },
        { name: '删除', icon: 'su-icon-delete', operation: 'delete' }
      ],
      currentDialogTitle: '新增接口',
      dialogFlag: false,
      imDiaLogForm: {
        name: '',
        url: '',
        method: 'GET',
        needParam: false,
        params: [],
        variables: [],
        scope: 'public',
        pageSize: 0
      },
      imdfRules: {
        // 应用组弹出表单验证规则
        name: [
          { required: true, message: '请输入接口名', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请输入url地址', trigger: 'blur' }
        ],
        method: [
          { required: true, message: '请选择提交方式', trigger: 'blur' }
        ],
        scope: [
          { required: true, message: '请选择权限范围', trigger: 'blur' }
        ]
      },
      urlReturn: '',
      urlReturnKey: [],
      checkList: [],
      template: '',
      jsonTem: [
        { label: 'name', value: 'name' },
        { label: 'age', value: 'age' },
        {
          label: 'list1',
          value: 'list1',
          children: [
            { label: 'name', value: 'name' },
            { label: 'age', value: 'age' },
            { label: 'sex', value: 'sex' }
          ]
        }
      ]
    }
  },
  mounted () {
    this.getData()
  },
  computed: {
    jsonTemplate () {
      let changeJson = JSON.stringify(this.jsonTem)
      return JSON.stringify(JSON.parse(changeJson), null, 2)
    }
  },
  methods: {
    getData (searchVal = '', renew = '') {
      this.tableLoading = true
      var interfaceURL = ''
      var interfaceName = ''
      if (this.searchType === 'interfaceURL') {
        interfaceURL = searchVal
      } else {
        interfaceName = searchVal
      }
      service.get('/v1/interface/showInterfaceList', {
        params: {
          url: interfaceURL,
          interfaceName: interfaceName,
          groupId: this.$route.params.id,
          page: this.currentPage,
          limit: this.pageSize
        }
      }).then(res => {
        this.tableLoading = false
        if (renew) {
          this.$swMessage.success('刷新成功')
        }
        this.tableData = res.data.map(item => {
          const paramsObj = JSON.parse(item.params)
          const params = []
          for (const key in paramsObj) {
            params.push({ name: key, value: paramsObj[key] })
          }
          return { name: item.interfaceName, url: item.url, method: item.method, params: params, variables: JSON.parse(item.variables), scope: item.scope, id: item.id, paged: item.paged, pageSize: item.pageSize }
        })
        this.tableCount = res.count
      }).catch(error => {
        this.$swMessage.error(error)
      })
    },
    selectionChange () {

    },
    changeSize (size) {
      this.pageSize = size
      this.currentPage = 1
      this.getData()
    },
    changePage (page) {
      this.currentPage = page
      this.getData()
    },
    searchHandle (val) {
      this.getData(val)
    },
    addInterface () {
      this.currentDialogTitle = '新增接口'
      this.imDiaLogForm.name = ''
      this.imDiaLogForm.url = ''
      this.imDiaLogForm.method = 'GET'
      this.imDiaLogForm.scope = 'public'
      this.dialogFlag = true
    },
    editInterfaceRow (id) {
      this.currentDialogTitle = '编辑接口'
      const tempRow = this.tableData.find(item => {
        return item.id === id
      })
      console.log(tempRow)
      this.imDiaLogForm = Object.assign({}, tempRow)
      this.checkList = []
      this.urlReturn = ''
      this.urlReturnKey = []
      this.dialogFlag = true
    },
    addParams () {
      this.imDiaLogForm.params.push({ name: '', value: '' })
    },
    addVariables () {
      if (!this.imDiaLogForm.variables) {
        this.imDiaLogForm.variables = []
      }
      this.imDiaLogForm.variables.push({ name: '' })
    },
    deleteRowParam (index) {
      this.imDiaLogForm.params.splice(index, 1)
    },
    deleteRowVariable (index) {
      this.imDiaLogForm.variables.splice(index, 1)
    },
    testUrl (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const formParam = {}
          this.imDiaLogForm.params.forEach(item => {
            item.name = item.name.replace(/(^\s*)|(\s*$)/g, '')
            if (item.name.length) {
              formParam[item.name] = item.value
            }
          })
          const param = {
            interfaceName: this.imDiaLogForm.name,
            url: this.imDiaLogForm.url,
            method: this.imDiaLogForm.method,
            scope: this.imDiaLogForm.scope,
            groupId: this.$route.params.id,
            params: JSON.stringify(formParam),
            variables: JSON.stringify(this.imDiaLogForm.variables),
            keys: this.checkList.join(),
            result: this.urlReturn,
            id: this.imDiaLogForm.id,
            template: this.template
          }
          service.post('/v1/interface/testInterface', param)
            .then((res) => {
              this.$swMessage({
                message: res.msg,
                type: 'success'
              })
              this.urlReturn = JSON.stringify(res.data, null, 4)
              this.urlReturnKey = resolveJson(res.data, '', '->', [])
            }).catch(error => {
              this.$swMessage.error(error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    operationHandle (id, operation) {
      if (operation === 'delete') {
        this.confirmDelete(id)
      } else if (operation === 'edit') {
        this.editInterfaceRow(id)
      }
    },
    confirmDelete (id) {
      this.$swConfirm('<p style="display: flex; justify-content: center; align-items: center; font-size: 16px; color: #000;"><i class="su-icon-question" style="font-size: 22px; color: #F5A623;margin-right: 8px"></i>确认要删除该接口吗？</p><br><p style="font-size: 14px; color: rgba(2, 21, 37,0.45); text-align: center;">删除后，该接口将不可恢复</p>', '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        service.get('/v1/interface/delDataInterface?id=' + id)
          .then((res) => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.getData()
          }).catch(error => {
            this.$swMessage.error(error)
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    submitDialogForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const formParam = {}
          this.imDiaLogForm.params.forEach(item => {
            item.name = item.name.replace(/(^\s*)|(\s*$)/g, '')
            if (item.name.length) {
              formParam[item.name] = item.value
            }
          })
          const param = {
            interfaceName: this.imDiaLogForm.name,
            url: this.imDiaLogForm.url,
            method: this.imDiaLogForm.method,
            scope: this.imDiaLogForm.scope,
            groupId: this.$route.params.id,
            params: JSON.stringify(formParam),
            variables: JSON.stringify(this.imDiaLogForm.variables),
            keys: this.checkList.join(),
            result: this.urlReturn,
            id: this.imDiaLogForm.id,
            template: this.template
          }
          let interfaceUrl = ''
          if (this.currentDialogTitle === '新增接口') {
            interfaceUrl = '/v1/interface/addInterface'
          } else {
            interfaceUrl = '/v1/interface/updateInterface'
          }
          service.post(interfaceUrl, param)
            .then((res) => {
              this.$swMessage({
                message: this.currentDialogTitle === '新增接口' ? '添加成功' : '修改成功',
                type: 'success'
              })
              this.dialogFlag = false
              this.getData()
            }).catch(error => {
              this.$swMessage.error(error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePreview (file) {
      console.log(file)
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    }

  },
  watch: {
    // 窗口关闭，模板template置空
    dialogFlag: {
      handler (val) {
        if (!val) {
          this.template = ''
        }
      },
      immediate: true
    }
  }
}
</script>
<style lang="scss" scoped>
.ff_interface {
  .td-header {
    box-sizing: border-box;
    height: auto !important;
    padding: 5px 20px;
    padding-bottom: 0;
    display: flex;
    justify-content: space-between;
    .tdh-left {
      display: flex;
      justify-content: center;
      align-items: center;
      .tdhl-rect-icon {
        margin-right: 4px;
        width: 3px;
        height: 12px;
        background: linear-gradient(
          177deg,
          rgba(97, 193, 190, 1) 0%,
          rgba(51, 148, 225, 1) 100%
        );
      }
      .tdhl-title {
        cursor: pointer;
        margin-right: 4px;
        height: 20px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        color: rgba(98, 111, 121, 1);
        line-height: 20px;
      }
      .tdhl-arrow-icon {
        margin-right: 4px;
        transform: rotate(-90deg);
        font-size: 12px;
        color: #bec9d2;
      }
      .tdhl-subtitle {
        height: 20px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        color: rgba(39, 56, 70, 1);
        line-height: 20px;
      }
    }
    .tdh-right {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #314250;
      border-bottom: 1px solid transparent;
      &:hover {
        border-bottom: 1px solid #314250;
      }
    }
  }
  .templateFormate textarea{
    border: 1px solid #DCDFE6;
    outline: none;
  }
}
</style>
